<template>
    <div class="component-settings-users">
        <div class="el-card__header text-left border" style="margin-left: 225px;" slot="header" v-if="$store.state.general.settingsMenuMode === 'vertical'">
            <h4>{{$route.path.split('settings/')[1] | formatVariableName}}</h4>
        </div>
        <div class="el-card__header text-left border" slot="header" v-else>
            <h4>{{$route.path.split('settings/')[1] | formatVariableName}}</h4>
        </div>
        <el-card class="box-card" id="main-header" shadow="never"
                 style="border: none; border-radius: 0px; min-height: 400px; background-color: #f4f7fa;"
                 body-style="background-color: #f4f7fa; padding: 20px 0px;">
            <div class="row">
                <div class="col-12">
                    <el-card class="box-card text-left" shadow="never">
                        <el-alert
                            :title="getMessage('update')"
                            type="success"
                            show-icon
                            v-if="$route.params.update === true">
                        </el-alert>
                        <el-alert
                            :title="getMessage('delete')"
                            type="success"
                            show-icon
                            v-if="$route.params.delete === true">
                        </el-alert>
                        <el-tabs v-model="activeName">
                            <el-tab-pane label="Active" name="Active">
                                <div class="row">
                                    <div class="col-12">
                                        <el-input
                                            v-model="search"
                                            placeholder="Type to search"
                                            style="width: 200px; float: left; margin-right: 5px;"
                                        />
                                        <el-button class="fr" type="primary" icon="el-icon-plus" plain @click="$router.push({'name': 'user-invite'})">Invite</el-button>
                                    </div>
                                </div>
                                <template>
                                    <el-table
                                        :data="tableData.filter(data => data['last_login'] !== 'None' && !search || data['last_login'] !== 'None' && data['last_name'].toLowerCase().includes(search.toLowerCase()))"
                                        style="width: 100%; margin: 20px 0px;"
                                        @row-click="rowClicked"
                                        :default-sort="{prop: 'email', order: 'ascending'}">
                                        <el-table-column>
                                            <template slot-scope="scope">
                                                <avatar :lighten="100" :username="scope.row['first_name'] + ' ' + scope.row['last_name']" :size="35"></avatar>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            v-for="col in columns"
                                            :key="col.key"
                                            :prop="col.prop"
                                            :label="col.label"
                                            sortable>
                                        </el-table-column>
                                    </el-table>
                                </template>
                            </el-tab-pane>
                            <el-tab-pane label="Invited" name="Invited">
                                <div class="row">
                                    <div class="col-12">
                                        <el-input
                                            v-model="search"
                                            placeholder="Type to search"
                                            style="width: 200px; float: left; margin-right: 5px;"
                                        />
                                        <el-button class="fr" type="primary"  icon="el-icon-plus" plain @click="$router.push({'name': 'user-invite'})">Invite</el-button>
                                    </div>
                                </div>
                                <template>
                                    <el-table
                                        :data="tableData.filter(data => data['last_login'] === 'None' && !search || data['last_login'] === 'None' && data['last_name'].toLowerCase().includes(search.toLowerCase()))"
                                        style="width: 100%; margin: 20px 0px;"
                                        @row-click="rowClicked"
                                        :default-sort="{'prop': 'Email', 'order': 'ascending'}">
                                        <el-table-column>
                                            <template slot-scope="scope">
                                                <avatar :lighten="100" :username="scope.row['first_name'] + ' ' + scope.row['last_name']" :size="35"></avatar>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            v-for="col in columns"
                                            :key="col.key"
                                            :prop="col.prop"
                                            :label="col.label"
                                            sortable>
                                        </el-table-column>
                                    </el-table>
                                </template>
                            </el-tab-pane>
                        </el-tabs>
                    </el-card>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import axios from '@/services/axios.js'
import { getTableHeaders, getHeadersWithAccessToken } from '../../functions.js'
import Avatar from 'vue-avatar'
export default {
    data () {
        return {
            users: {},
            activeName: 'Active',
            tableData: [],
            columns: [],
            search: ''
        }
    },
    components: {
        Avatar
    },
    methods: {
        rowClicked (row, column, event) {
            this.$router.push({ name: 'settings-user-detail', query: { 'user_id': row.user_id } })
        },
        getMessage (type) {
            if (type === 'update') {
                return 'User ' + this.$route.params.user_id + ' successfully updated'
            } else {
                return 'User ' + this.$route.params.user_id + ' deleted'
            }
        }
    },
    created () {
        axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_USERS_API_BASE_URL_DEV : process.env.VUE_APP_USERS_API_BASE_URL) + '/users', { 'headers': getHeadersWithAccessToken() })
            .then(response => {
                this.tableData = response.data.data
                this.columns = getTableHeaders(Object.keys(response.data.data[0]))
                let obj = this.columns.find(x => x.prop === 'user_id')
                let idx = this.columns.indexOf(obj)
                this.columns.splice(idx, 1)
                obj = this.columns.find(x => x.prop === 'is_superuser')
                idx = this.columns.indexOf(obj)
                this.columns.splice(idx, 1)
            })
            .catch(error => {
                console.log(error)
            })
    }
}
</script>

<style lang="scss">
.component-settings-users {
    p {
        margin-bottom: 0px;
    }
    .el-card__body {
        padding-bottom: 0px !important;
    }
}
</style>
